<template>
  <a-radio :class="bem.b()" v-bind="attrs">
    <template v-for="item in Object.keys($slots)" :key="item" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </a-radio>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'
// import { Radio } from 'ant-design-vue'
import { createNamespace } from '@ll-plus/utils'
defineOptions({ name: 'LlRadio' })
const attrs = useAttrs()
const bem = createNamespace('radio')
</script>
